import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Pill',
  props: {
    label: {},
    bgColor: {},
    color: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "text-center",
    style: _normalizeStyle({
      color: __props.color,
      backgroundColor: __props.bgColor,
      width: '5rem',
      padding: '0.25rem',
      fontSize: 'var(--font-xs)',
      textTransform: 'capitalize',
      borderRadius: '3px',
      letterSpacing: '-3%',
    })
  }, _toDisplayString(__props.label), 5))
}
}

})